/* eslint-disable no-console */

export default {
  log(...args) { console.log(...args); },
};




// WEBPACK FOOTER //
// ./src/logger.js